import { render, staticRenderFns } from "./AssessmentInterviewQuestionStatement.vue?vue&type=template&id=5b467e26&scoped=true&"
import script from "./AssessmentInterviewQuestionStatement.vue?vue&type=script&lang=js&"
export * from "./AssessmentInterviewQuestionStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b467e26",
  null
  
)

export default component.exports